import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { withViewport } from '../../util/uiHelpers';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './GroundworksContractorsPage.module.css';
import HeroSection from './Sections/HeroSection';
import VisitSupplierSection from './Sections/VisitSupplierSection';
import FeatureSection from './Sections/FeatureSection';

export const GroundworksContractorsPageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;
  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;
  const title = '';
  const description = '';

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={description}
      title={title}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <HeroSection />
          <FeatureSection />
          <VisitSupplierSection />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

GroundworksContractorsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const GroundworksContractorsPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withViewport,
  injectIntl
)(GroundworksContractorsPageComponent);

export default GroundworksContractorsPage;
